import { getSettingEnableLargerPageSizeOnLoggedOutCategory } from "@faire/retailer/settings/getSettingEnableLargerPageSizeLoggedOutCategory";

export const useLoggedOutCategoryPageRequestPageSize = () => {
  const FULL_LOGGED_OUT_PAGE_SIZE = 37;
  const LARGER_FULL_LOGGED_OUT_PAGE_SIZE = 57;

  const isProductPageSizeXP =
    getSettingEnableLargerPageSizeOnLoggedOutCategory();
  return isProductPageSizeXP
    ? LARGER_FULL_LOGGED_OUT_PAGE_SIZE
    : FULL_LOGGED_OUT_PAGE_SIZE;
};
